<template>
  <li class="sidenav-item">
    <router-link :to="url">
      <span class="sidenav-item__icon">
        <slot name="icon"></slot>
      </span>
      <span class="sidenav-item__title" :class="{ 'sidenav-item__title-collapse': isSideNavCollapsed }">{{ title }}</span>
    </router-link>
  </li>
</template>

<script>
export default {
  // props: ["title", "url"],
  props: {
    title: String,
    url: {
      type: String,
      required: false,
    },
  },
  computed: {
    isSideNavCollapsed() {
      return this.$store.getters.isSideNavCollapsed;
    },
  },
};
</script>

<style scoped>
.sidenav-item__icon {
  margin-right: 1rem;
}
a {
  text-decoration: none;
}
.sidenav-item {
  /* margin-bottom: 1.2rem; */
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  padding-left: 2rem;
}
.sidenav-item__title {
  color: #ffffff;
  font-weight: normal;
  font-size: 0.9rem;
}
.sidenav-item__title-collapse{
  display: none;
}
</style>
